import type { ReactElement } from 'react';
import {
  MINUTES_PER_DAY,
  formatMinuteOfDay,
  mod,
} from '../../../domain/scheduling/scheduleMath';
import { HOURS, minuteToPercent } from './timelineUtils';

interface TimeAxisProps {
  minuteOfDay: number;
}

/** Sticky 24-hour header. Carries the Hour:Minute tag for the now-line. */
export function TimeAxis({ minuteOfDay }: TimeAxisProps): ReactElement {
  const left = minuteToPercent(mod(minuteOfDay, MINUTES_PER_DAY));
  return (
    <div className="fsg-row fsg-axis" role="row">
      <div className="fsg-axis-corner" role="columnheader">
        Aircraft
      </div>
      <div className="fsg-axis-hours" role="presentation">
        {HOURS.map((hour) => (
          <span key={hour} className="fsg-axis-hour" role="columnheader">
            {hour < 10 ? `0${hour}` : hour}
          </span>
        ))}
        <span className="fsg-now-tag" style={{ left: `${left}%` }}>
          {formatMinuteOfDay(minuteOfDay)}
        </span>
      </div>
    </div>
  );
}
